/**
 * G4-T19.6: Dashboard yüklenme süresi ölçümü
 * performance.mark() ile API çağrı sürelerini loglar.
 */

export function markStart(label) {
  performance.mark(`${label}:start`);
}

export function markEnd(label) {
  performance.mark(`${label}:end`);
  try {
    performance.measure(label, `${label}:start`, `${label}:end`);
    const [entry] = performance.getEntriesByName(label);
    if (entry) {
      const ms = Math.round(entry.duration);
      if (ms > 500) {
        console.warn(`[PerfMonitor] Yavaş: ${label} — ${ms}ms`);
      } else {
        console.debug(`[PerfMonitor] ${label} — ${ms}ms`);
      }
    }
  } catch (_) {
    // eski tarayıcılarda performance.measure desteklenmeyebilir
  }
}

/**
 * fetch wrapper: otomatik süre ölçümü yapar.
 * Kullanım: await timedFetch('dashboard', '/api/dashboard/salesrep')
 */
export async function timedFetch(label, url, options) {
  markStart(label);
  try {
    const response = await fetch(url, options);
    return response;
  } finally {
    markEnd(label);
  }
}
